/**
 * en-GB messages added by Phase 2 task S15 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s15EnGB = {
    // Emails (module templates companion.invite and companion.magic_link)
    'email.companion.invite.subject': 'Set up the {tenant} sign-in app',
    'email.companion.invite.body': 'Hello {name}. {tenant} uses the CloudSign app to sign you in and out. To set it up: 1. Install CloudSign from Google Play. 2. On your phone, tap the button below, or scan the attached code from the app. This link works once and expires in {days} days.',
    'email.companion.invite.button': 'Open in the CloudSign app',
    'email.companion.magic_link.subject': 'Your sign-in link for {tenant}',
    'email.companion.magic_link.body': 'Hello {name}. Tap the button below on your phone to sign in to the CloudSign app. It works once and expires in {minutes} minutes. If you did not ask for it, you can ignore this email.',
    'email.companion.magic_link.button': 'Sign in to the app',
    // Errors
    'error.companion_not_enabled': 'The Companion app is not switched on for this group.',
    'error.companion_not_allowed': 'Your group does not allow this in the app.',
    'error.companion_location_not_allowed': 'Location sign-in is not available. It needs your group to allow it and your agreement in the app.',
    'error.companion_invite_needs_email': 'This person has no email address, so no invite can be sent.',
};
//# sourceMappingURL=s15.js.map